import { Card as MuiCard, CardProps, styled } from '@mui/material';
import { CardActionArea } from '@mui/material';
import { spacing, SpacingProps, sizing, SizingProps } from '@mui/system';
import { isSpacingProp } from '../../Utils/spacingUtils';
import { isSizingProp } from '../../Utils/sizingUtils';

export interface ICardProps extends SpacingProps, SizingProps {
  raised?: boolean;
  square?: boolean;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  elevation?: number;
  // miniCard?: CommonPropsAndTypes.MiniCardColorType | false;
  children?: React.ReactNode;
  selected?: boolean;
  /** Anpassa kortet till att det visas i ett kort */
  cardInCard?: boolean;
  /** Bakgrund för kortet (style för css background, använd för mer avancerade bakgrunder än backgroundColor) */
  background?: string;
  /** Bakgrundsfärg för kortet (används inte om background är satt)*/
  backgroundColor?: string;
  overflow?: string;
  flex?: boolean;
  flexGrow?: number;
  border?: string;
  noBoxShadow?: boolean;
  /** Specialutseende för AI-insikter */
  aiInsightsElevated?: boolean;
  /** Aktivera klick-ripple på CardActionArea */
  enableRipple?: boolean;
}

interface IStyledCardProps extends CardProps, SpacingProps, SizingProps {}
const EDStyledCard: React.FC<React.PropsWithChildren<IStyledCardProps>> =
  styled(MuiCard, {
    name: 'EDStyledCard',
    shouldForwardProp: prop => !isSpacingProp(prop) && !isSizingProp(prop),
  })(spacing as any, sizing);

export const EDCard: React.FC<React.PropsWithChildren<ICardProps>> = props => {
  const {
    selected,
    cardInCard,
    background,
    backgroundColor,
    overflow,
    flex,
    flexGrow,
    children,
    border,
    noBoxShadow,
    aiInsightsElevated,
    enableRipple = false,
    ...MuiProps
  } = props;
  return (
    <EDStyledCard
      sx={[
        !!props.onClick && {
          '@media (hover: hover)': {
            '&:hover': {
              background: theme => theme.customProperties.Fade.BlueGray.hover,
            },
          },
        },
        !!selected && {
          background: theme => theme.customProperties.Fade.BlueGray.selected,
        },
        !!background && {
          background: props.background,
        },
        !!backgroundColor &&
          !background && {
            backgroundColor: backgroundColor,
          },
        !!cardInCard && {
          borderBottom: '1px solid rgba(0, 0, 0, 0.22)',
          borderRadius: 0,
        },
        !!overflow && {
          overflow: overflow,
        },
        !!flex && {
          display: 'flex',
          flexDirection: 'column',
        },
        !!flexGrow && {
          flexGrow: flexGrow,
        },
        !!border && {
          border: props.border,
        },
        !!noBoxShadow && {
          boxShadow: 'none',
        },
        !!aiInsightsElevated && {
          boxShadow: theme => `9px 11px 8px -9px ${theme.palette.grey[400]}`,
        },
      ]}
      {...MuiProps}
    >
      {!props.onClick ? (
        children
      ) : (
        <CardActionArea disableRipple={!enableRipple}>
          {children}
        </CardActionArea>
      )}
    </EDStyledCard>
  );
};
